<template>
  <div v-if="loading" class="loading-overlay">
    <div class="loading-content">
      <div class="loader">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { gsap } from 'gsap';

const props = defineProps(['showLoading']);
const loading = ref(props.showLoading);

watch(() => props.showLoading, async (newVal) => {
  loading.value = newVal;
  if (loading.value) {
    await nextTick();
    gsap.fromTo(
      ".circle",
      { opacity: 0, scale: 0, y: 0 },
      { opacity: 1, scale: 1, y: -20, stagger: 0.3, repeat: -1, yoyo: true }
    );
  }
});

</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.loader {
  display: flex;
  gap: 10px;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: theme(colors.brand.indigo);
}
</style>
